import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-oral-deposition-status',
  templateUrl: './oral-deposition-status.component.html',
  styleUrls: ['./oral-deposition-status.component.scss']
})
export class OralDepositionStatusComponent implements OnInit {
  @Input() status: string;

  constructor() { }

  ngOnInit(): void {
  }

}
